<template>
  <h-msg-box
    v-model="showModal"
    @on-close="handleMsgBoxClose"
    width="480"
    class="financial-competition-modal"
    :mask-closable="false"
  >
    <p slot="header">
      <span class="model-header">移除通知</span>
    </p>
    <div>
      <div class="team-name">
        你已被
        <span>{{
          competeUser.last_team ? competeUser.last_team.captain_name : '-'
        }}</span>
        移除队伍
        <span>{{
          competeUser.last_team ? competeUser.last_team.team_name : '-'
        }}</span>
      </div>
    </div>
    <div slot="footer">
      <comp-button class="btn-icon" @click="handleMsgBoxClose"
        >知道了</comp-button
      >
    </div>
  </h-msg-box>
</template>

<script>
import { mapGetters } from 'vuex'
import { CompButton } from '../common'

export default {
  name: 'RemoveOutNotify',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  components: {
    CompButton
  },
  computed: {
    ...mapGetters(['competeUser'])
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    handleMsgBoxClose() {
      this.showModal = false
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.showModal = newValue
    },
    showModal(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.team-name {
  font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
    Verdana, 'PingFang SC';
  font-size: 14px;
  color: #333;
  text-align: center;
  line-height: 32px;
  span {
    color: #f2b044;
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/TeamInvite/RemoveOutNotify.vue